import { render, staticRenderFns } from "./freecomplex.vue?vue&type=template&id=1791ecab&scoped=true&"
import script from "./freecomplex.vue?vue&type=script&lang=js&"
export * from "./freecomplex.vue?vue&type=script&lang=js&"
import style0 from "./freecomplex.vue?vue&type=style&index=0&id=1791ecab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791ecab",
  null
  
)

export default component.exports